import { render, staticRenderFns } from "./ResultCompletenessColumnChangesModal.vue?vue&type=template&id=0e80bbbd&"
import script from "./ResultCompletenessColumnChangesModal.vue?vue&type=script&lang=ts&"
export * from "./ResultCompletenessColumnChangesModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports